import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'styled-components';

const Fill = styled.div`
  flex: 1 1 auto;
`;

export default Fill;
